export default "__VITE_ASSET__NxzFTTe3__"